export default __webpack_public_path__ + "static/media/Oneview Logo New.0f421266.webp";